import { PayloadAction } from '@reduxjs/toolkit'
import { EReportColumnHeader } from '@unfoldrtech/portal-mic'
import { TReportingFilters } from '@unfoldrtech/portal-mic/dist/src/models/types'

const setFilterBy = (
  state: TReportingFilters,
  action: PayloadAction<{
    filterBy?: EReportColumnHeader
  }>
) => {
  state.filterBy = action.payload.filterBy as TReportingFilters['filterBy']
}

export default setFilterBy
